"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApolloClient = void 0;
const typed_redux_saga_1 = require("typed-redux-saga");
const api_1 = require("../../api");
function* getApolloClient() {
    const apolloClient = yield* (0, typed_redux_saga_1.getContext)(api_1.CONTEXT_NAME.client);
    return apolloClient;
}
exports.getApolloClient = getApolloClient;
